module.exports = __webpack_public_path__ + "img/folder-question.54f35006.svg";